import type { AnchorHTMLAttributes } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
    onClick?(...args: unknown[]): unknown;
};

export const StyledLink = styled.a.attrs((props: LinkProps) => ({
    target: props.target ?? "_self",
}))`
    color: ${colorsPalettes.blue[400]} !important; /* this is needed because of AntD default styles for anchor tags */
    text-decoration: none;
    cursor: ${(props: LinkProps) => (props.href || props.onClick ? "pointer" : "auto")};
`;
StyledLink.displayName = "StyledLink";
